export default __webpack_public_path__ + "static/media/add-contact.69557ac5.png";